import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0053',
    ecrans: ['00-2'],
    params: ['?agacleint']
});

